import React from 'react'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import { withStyles } from '@material-ui/core/styles'
import srids from '../../constants/srids.js'

const styles = {
	select: {
		width: "100%"
	}
}

const SridSelector = ({ classes, value, onChange }) => (
	<Select value={value} onChange={onChange} className={classes.select}>
        { srids.map(({ srid, name }) => <MenuItem value={srid} key={srid}>{name}</MenuItem>) }
    </Select>
)

export default withStyles(styles)(SridSelector)



// WEBPACK FOOTER //
// ./src/components/Filter/SridSelector.js